import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="flex justify-between items-center text-xs text-gray-500">
      <span className="font-medium">&copy;{currentYear}</span>
      <span className="font-medium text-right">
        POWERED BY <span className="text-primary-600 font-semibold hover:text-primary-700 transition-colors">smartsourcing.ng</span>
      </span>
    </div>
  );
};

export default Footer;